// extracted by mini-css-extract-plugin
export default {"gameplay_main":"GamePlayVideoReact_gameplay_main__ITEcb","skip_btn":"GamePlayVideoReact_skip_btn__+TDCJ"};